export enum ConnectCrmOrgStateEnum {
  NotConnected,
  Connecting,
  Connected,
  Error,
}
